var HEADER_VARIANT = {
  MAIN: 'Main',
  SUB: 'Sub'
};
var TAB_ALIGNMENT = {
  LEFT: 'left',
  RIGHT: 'right'
};

export { HEADER_VARIANT, TAB_ALIGNMENT };
